import { AlertTriangle, Link2Off } from "lucide-react";

import { ColocaEmpty } from "@/shared/components/feedback/ColocaEmpty";
import useTranslations from "@/shared/lang/useTranslations";

export interface InvalidLinkScreenProps {
  /** `expired` for an expired/rejected link token (401); `invalid` for an unknown link (404 / other). */
  kind: "expired" | "invalid";
}

/** Full-screen fallback when the link token can't be resolved into a session. */
export function InvalidLinkScreen({ kind }: InvalidLinkScreenProps) {
  const { t } = useTranslations("verification");
  const isExpired = kind === "expired";
  return (
    <ColocaEmpty
      icon={isExpired ? AlertTriangle : Link2Off}
      title={t(isExpired ? "result_expired_title" : "invalid_title")}
      description={t(isExpired ? "result_expired_description" : "invalid_description")}
    />
  );
}
